
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { WTPRecirculationOfPupmDeleteAPI, WTPRecirculationOfPupmExportTableDataAPI, WTPRecirculationOfPupmTableDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/PreventiveData/RecirculationOfPupmpSlice'
import { Loading } from '../../../../../Helper/Loading'
import DeletePopup from '../../GardenPopup/DeletePopup'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { WTPPreventiveRecirculationWorkExportData } from './WTPPreventiveRecirculationExport'


export default function WTPPreventiveRecirculationOfPumpPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [ExportData, setExportData] = useState([])
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [Heading, setHeading] = React.useState(false)

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [DeletePopupShow, setDeletePopupShow] = useState()

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }

    const handleClear = () => {
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate('')
    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: year?.ID,
            M_MonthID: Month?.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleGetExport: handleGetExport
        }
        dispatch(WTPRecirculationOfPupmTableDataAPI({ data }))
    }, [IsPost, isSearch, IsClear, year?.ID, Month?.ID])

    const { tableData, isLoading } = useSelector(state => state.WTPRecirculationOfPupmTableData)

    const handleGetExport = () => {
        const data = {
             M_FinancialYearID: year?.ID,
            M_MonthID: Month?.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: '99999',
        }
        dispatch(WTPRecirculationOfPupmExportTableDataAPI({ data }))
    }
    const { ExporttableData, isExportLoading } = useSelector(state => state.WTPRecirculationOfPupmExportTableData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WTP_Recirculation_PumpID: item?.t_wtP_Recirculation_PumpID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
        }
        dispatch(WTPRecirculationOfPupmDeleteAPI({ data }))
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName} />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId} />
                    <div className="content">
                        {/* <!-- [ breadcrumb ] start --> */}
                        {/* <!-- [ Main Content ] start --> */}
                        <div className='data_mob'>
                            <div className="row m-1 pb-4 master_border">
                                <div className='mt-2'>
                                    <h5>Recirculation Of Pump</h5>
                                    <div className="float-end butt">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                // GardenExporttableData && GardenExporttableData.table && GardenExporttableData.table.length
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <WTPPreventiveRecirculationWorkExportData
                                                    ExcelData={ExporttableData}
                                                    name='Recirculation Of Pump'
                                                />
                                        }
                                    </div>
                                </div>
                                <div className="row m-0 pt-1">
                                    <div className="col-12 py-0 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">
                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-6 col-lg-2 ">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            onChange={(e) => setFromDate(e.target.value)}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-lg-3 col-md-6">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />

                                                </div>

                                                <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>

                                            </div>
                                            <div className="row mob_table table-responsive pt-3">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">

                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Date</th>
                                                            <th>Pump</th>
                                                            <th>Start Time</th>
                                                            <th>Stop Time</th>
                                                            <th>Sump Start level (Mtr.)</th>
                                                            <th>Sump Stop level (Mtr.)</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                                                    <td style={{ textAlign: 'right' }}>{i?.pumpStartDate ? moment(i?.pumpStartDate).format('DD-MM-YYYY') : '-'}</td>
                                                                    <td>{i?.pumpNumber ? i?.pumpNumber : '-'}</td>
                                                                    <td style={{ textAlign: 'right' }}>{i?.pumpStartTime ? i?.pumpStartTime : '-'}</td>
                                                                    <td style={{ textAlign: 'right' }}>{i?.pumpStopTime ? i?.pumpStopTime : '-'}</td>
                                                                    <td style={{textAlign:'right'}}>{i?.startSumpLevel ? i?.startSumpLevel : '-'}</td>
                                                                    <td style={{textAlign:'right'}}>{i?.stopSumpLevel ? i?.stopSumpLevel : '-'}</td>
                                                                    <td style={{textAlign:'center'}}>
                                                                        {
                                                                            (i?.pumpStartDate && moment(i?.pumpStartDate).format('DD-MM-YYYY')) == moment().format('DD-MM-YYYY') ?
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    item={i}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                />
                                                                                :
                                                                                '-'
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* {
                    WTPQuantityOfWaterPagePopupShow ?
                        <WTPQuantityOfWaterPagePopup
                            open={WTPQuantityOfWaterPagePopupShow}
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                        // Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                } */}

                </div>
            </div>
        </>


    )
}